<template>

    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <EntityTabLinks />
                    <CRow class="pl-3 pb-3" />
                    
                    <CRow class="pb-3">
                        <CCol sm="12">
                            <CButton color="primary" @click="create">Создать</CButton>
                        </CCol>
                    </CRow>                    
                    <CRow class="pl-3">
                        <table class="table">
                            <thead>
                                <th></th>
                                <th>Название</th>
                                <th>Стоимость</th>
                                <th>Активен</th>
                                <th></th>
                            </thead>
                            <draggable v-model="variants" tag="tbody">
                                <tr v-for="variant in variants" :key="variant.title">
                                    <td><CIcon
                                        :height="24"
                                        :content="$options.icons.cilCursorMove"
                                        class="handle" /></td>
                                    <td>{{ variant.title }}</td>
                                    <td>{{ variant.price }}</td>
                                    <td>
                                        <CBadge :color="getBadge(variant.enabled)">
                                            &nbsp;{{ variant.enabled ? 'Да' : 'Нет' }}&nbsp;
                                        </CBadge>
                                    </td>
                                    <td>
                                        <CButton @click="edit(variant.id)"><CIcon :content="$options.icons.cilPencil" class="handle" /></CButton>
                                        <CButton @click="removeConfirmation(variant.id)"><CIcon :content="$options.icons.cilTrash" class="handle" /></CButton>
                                    </td>
                                </tr>
                            </draggable>
                        </table>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save">Сохранить</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

        <CModal
            :title="createEditModalTitle"
            :show.sync="createEditModal.visible"
            :footer="false">
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <CForm>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Название</CCol>
                            <CCol sm="9">
                                <CInput
                                    v-model="createEditModal.variant.title"
                                    placeholder="Название варианта"
                                    description="Обязательно для заполнения"
                                />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Стоимость</CCol>
                            <CCol sm="9">
                                <CInput
                                    v-model="createEditModal.variant.price"
                                    placeholder="Стоимость варианта"
                                    description="Введите 0, если не влияет на стоимость блюда"
                                />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Активен</CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="createEditModal.variant.enabled"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="createEditModal.visible = false">Отмена</CButton>
                    <CButton
                        color="primary"
                        class="ml-3"
                        @click="createUpdateModifier">{{ createEditModalButton }}</CButton>
                </div>
            </template>
        </CModal>

        <CModal
            title="Подтверждение"
            color="danger"
            :show.sync="deleteModal.visible"
            :footer="false">
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <p>Вы действительно хотите удалить модификатор? Это действие нельзя будет отменить.</p>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="deleteModal.visible = false">Отмена</CButton>
                    <CButton
                        color="danger"
                        class="ml-3"
                        @click="remove">Удалить</CButton>
                </div>
            </template>
        </CModal>


    </CRow>
</template>

<script>
    import Vue from 'vue';
    import draggable from 'vuedraggable';
    import { cilCursorMove, cilTrash, cilPencil } from '@coreui/icons';
    import EntityTabLinks from '@/components/entities/EntityTabLinks';

    export default {

        name: 'EntityVariants',

        components: {
            EntityTabLinks,
            draggable,
        },
  
        data () {
            return {
                entity: {},
                variants: [],
                createEditModal: {
                    visible: false,
                    editMode: false,
                    editId:0,
                    variant: {
                        title: '',
                        price: 0,
                        enabled: false,
                        position: 0
                    }
                },
                deleteModal: {
                    visible: false,
                    variantId: 0
                }
            }
        },
    
        computed: {
            createEditModalTitle: function() {
                return this.createEditModal.editMode ? 'Редактирование варианта' : 'Создание варианта';
            },
            createEditModalButton: function() {
                return this.createEditModal.editMode ? 'Сохранить' : 'Создать';
            }
        },

        mounted() {
            const id = this.$route.params.id;
            const code = this.$route.params.code;
            Vue.axios.get(`/entities/get/${id}`)
                .then(resp => {
                    this.entity = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios.get(`/entities/${code}/variants/${id}`)
                .then(resp => {
                    this.variants = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        icons: {
            cilCursorMove,
            cilTrash,
            cilPencil
        },

        methods: {

            create() {
                this.createEditModal.editMode = false;
                this.createEditModal.variant.title = '',
                this.createEditModal.variant.price = 0;
                this.createEditModal.variant.enabled = true;
                this.createEditModal.visible = true;
            },

            createUpdateModifier() {
            
                if(!this.createEditModal.variant.title) {
                    this.$root.$emit('showError', 'Название варианта является обязательным.');
                    return;
                }
                if(this.createEditModal.variant.price === null) {
                    this.$root.$emit('showError', 'Стоимость является обязательной для заполнения.');
                    return;
                }

                if(this.createEditModal.editMode) {
                    Vue.axios.post(
                        `/entities/${this.$route.params.code}/variants/${this.entity.id}/update/${this.createEditModal.editId}`,
                        this.createEditModal.variant)
                        .then(resp => {
                            const justUpdated = resp.data;
                            const _variants = this.variants.slice();
                            for(var i = 0; i < _variants.length; i++) {
                                if(_variants[i].id === justUpdated.id) {
                                    _variants[i] = justUpdated;
                                }
                            }
                            this.variants = _variants;
                            this.createEditModal.visible = false;
                        })
                        .catch(() => {
                            this.$root.$emit('showError', 'Ошибка сохранения.');
                        });
                } else {
                    Vue.axios.post(`/entities/${this.$route.params.code}/variants/${this.$route.params.id}/create`, this.createEditModal.variant)
                        .then(resp => {
                            const justCreated = resp.data;
                            const _variants = this.variants.slice();
                            _variants.push(justCreated);
                            this.variants = _variants;
                            this.createEditModal.visible = false;
                        })
                        .catch(() => {
                            this.$root.$emit('showError', 'Ошибка сохранения.');
                        });
                }
            },

            edit(id) {
                this.createEditModal.editId = id;
                this.createEditModal.editMode = true;
            
                var _variant = {};
                for(var i = 0; i < this.variants.length; i++) {
                    if(this.variants[i].id === id) {
                        _variant = this.variants[i];
                    }
                }

                this.createEditModal.variant.title = _variant.title,
                this.createEditModal.variant.price = _variant.price;
                this.createEditModal.variant.enabled = _variant.enabled;
                this.createEditModal.variant.position = _variant.position;
            
                this.createEditModal.visible = true;
            },

            save() {
                // Save order only
                const reorder = [];
                let index = 0;
                this.variants.forEach(variant => {
                    reorder.push({
                        id: variant.id,
                        position: ++index
                    });
                });
                Vue.axios.post(`/entities/${this.$route.params.code}/variants/${this.$route.params.id}/reorder`, { reorder })
                    .then(() => {
                        this.$router.push(`/entities/${this.$route.params.code}/${this.$route.params.id}`)
                    })
                    .catch(() => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },

            removeConfirmation(id) {
                this.deleteModal.variantId = id;
                this.deleteModal.visible = true;
            },

            remove() {
                const id = this.deleteModal.variantId;
                Vue.axios.delete(`/entities/${this.$route.params.code}/variants/${this.$route.params.id}/${id}`)
                    .then(() => {
                        const _variants = [];
                        for(var i = 0; i < this.variants.length; i++) {
                            if(id != this.variants[i].id) {
                                _variants.push(this.variants[i]);
                            }
                        }
                        this.variants = _variants;
                        this.deleteModal.visible = false;
                    })
                    .catch(() => {
                        this.$root.$emit('showError', 'Ошибка удаления.');
                    });
            },

            goBack() {
                this.$router.push({ path: `/entities/${this.$route.params.code}/${this.$route.params.id}` })
            },

            getBadge(status) {
                return status ? 'success' : 'secondary';
            },
        }
    }

</script>
<style scoped>
.handle {
  cursor: pointer;
}
</style>
